import * as React from 'react';

import type { Permission } from './api/fetch-permissions/fetchPermissions.types';

export interface PermissionsContextValue {
  permissions: Permission[];
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  hasPermission: (permissionName: string) => boolean;
}

export interface PermissionsProviderProps {
  children: React.ReactNode;
}

export const PermissionsContext = React.createContext<
  PermissionsContextValue | undefined
>(undefined);
